import { capitalize, get } from "lodash";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

interface CustomerData {
  id: string;
  name: string;
  email: string;
  phone: string;
  notes: string;
  tags: string;
  branch_id: string;
  credit_balance: string;
  credit_limit: string;
  // Add any other properties that `data` might have
}

interface CustomerDetailModalProps {
  isOpen: boolean;
  toggle: () => void;
  data: CustomerData | null; // data can be null if it's not available
}

const CustomerDetailModal = (props: CustomerDetailModalProps) => {
  const { isOpen, toggle, data } = props;

  // Check if data is defined before accessing its properties
  if (!data) {
    return null; // or you could return a fallback UI like a loading spinner
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">Customer Details</h5>
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <div className="table-responsive">
            <Table className="table-borderless mb-0 ">
              <tbody>
                <tr>
                  <th scope="row" style={{ width: "200px" }}>
                    ID :
                  </th>
                  <td>#{data.id}</td>
                </tr>
                <tr>
                  <th scope="row">Name:</th>
                  <td>{data.name}</td>
                </tr>
                <tr>
                  <th scope="row">Email:</th>
                  <td>{data.email}</td>
                </tr>
                <tr>
                  <th scope="row">Phone:</th>
                  <td>{capitalize(data.phone)}</td>
                </tr>

                <tr>
                  <th scope="row">Branch_ID:</th>
                  <td>#{capitalize(data.branch_id)}</td>
                </tr>
                <tr>
                  <th scope="row">Tags:</th>
                  <td>
                    {data.tags ? capitalize(data.tags) : "No Tags Available"}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Notes:</th>
                  <td>
                    {data.notes ? capitalize(data.notes) : "No Notes Available"}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Credit_Balance:</th>
                  <td>
                    {data.credit_balance ? capitalize(data.credit_balance) : 0}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Credit_Limit:</th>
                  <td>
                    {data.credit_limit ? capitalize(data.credit_limit) : 0}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomerDetailModal;
